import React, {Component} from "react";
import './ui.css'

class Ui extends Component {
	render() {
		return (
			<p className="ui-text">this is a ui component</p>
		);
	}
}

/*
 * Navigation Bar Component
 *
 *
*/
class NavigationBar extends Component {
	// Navigation Bar 
	render() {
		return (
			<div>
				<p>
					NavigationBar
				</p>
			</div>
		);
	}
}

/*
 * Other component
 *
*/
class OtherComponent extends Component {
	render() {
		return (
			<div>
				<h3>Other Component</h3>
			</div>
		);
	}
}

export default Ui;
export {NavigationBar, OtherComponent};
